import { db } from '../firebaseInit'
import _ from 'lodash'

export default {
  state: {
    templates: [],
    templateTasks: []
  },
  mutations: {
    updateTemplate (state, payload) {
      const templateIndex = state.templates.findIndex(x => x.id === payload.template.id)
      const template = state.templates[templateIndex]
      state.templates.splice(templateIndex, 1)
      if (!payload.update.delete) {
        state.templates.push({ ...template, ...payload.update })
      }
    },
    deleteTemplateTask (state, payload) {
      const index = state.templateTasks.findIndex(x => x.taskId === payload.taskId)
      state.templateTasks.splice(index, 1)
    },
    saveTemplateTask (state, payload) {
      if (payload.type === 'edit') {
        const index = state.templateTasks.findIndex(x => x.taskId === payload.createTemplateTask.taskId)
        state.templateTasks.splice(index, 1)
      }
      state.templateTasks.push(payload.createTemplateTask)
    },
    getTemplates (state, payload) {
      state.templates.push(payload)
      if (payload.tasks) {
        payload.tasks.forEach(task => {
          state.templateTasks.push(task)
        })
      }
    },
    nameChange (state, payload) {
      let nameChange = _.filter(state.dynamicTasks, {after_task: payload.previousName})
      nameChange.forEach((item, index) => {
        nameChange[index].after_task = payload.newName
      })
      state.dynamicTasks = _.reject(state.dynamicTasks, {after_task: payload.previousName})
      state.dynamicTasks = state.dynamicTasks.concat(nameChange)
    }
  },
  actions: {
    updateTemplate ({commit}, payload) { // { template: template, update: { deleted: true} }
      db.collection('taskTemplates').doc(payload.template.id).update(payload.update).then(() => {
        commit('updateTemplate', payload)
      })
    },
    deleteTemplateTask ({commit}, payload) {
      db.collection('taskTemplates').doc(payload.taskTemplateId).get().then(result => {
        let tasks = result.data().tasks
        let afterTasks = tasks.map(m => m.after_task)
        // Check for dependant tasks
        if (afterTasks && afterTasks.includes(payload.taskId)) {
          alert('This task cannot be deleted! Other tasks are dependant on it.')
          return
        }
        let taskIndex = tasks.findIndex(i => i.taskId === payload.taskId)
        tasks.splice(taskIndex, 1)
        db.collection('taskTemplates').doc(payload.taskTemplateId).update({ tasks: tasks }).then(() => {
          commit('deleteTemplateTask', payload)
        })
      })
    },
    saveTemplateTask ({commit}, payload) {
      if (payload.type === 'new') {
        let milliseconds = String((new Date()).getTime())
        let timestamp = milliseconds + '-' + Math.floor(Math.random() * 1000)
        payload.createTemplateTask.taskId = timestamp
      }
      db.collection('taskTemplates').doc(payload.createTemplateTask.taskTemplateId).get().then(result => {
        let tasks = result.data().tasks
        if (tasks) {
          if (payload.type === 'new') {
            tasks.push(payload.createTemplateTask)
          } else { // If Edit
            let taskIndex = tasks.findIndex(i => i.taskId === payload.createTemplateTask.taskId)
            tasks[taskIndex] = payload.createTemplateTask
          }
        } else {
          tasks = [payload.createTemplateTask]
        }
        db.collection('taskTemplates').doc(payload.createTemplateTask.taskTemplateId).update({ tasks: tasks }).then(() => {
          commit('saveTemplateTask', payload)
        })
      })
    },
    createTemplate ({commit, getters}, payload) {
      let milliseconds = String((new Date()).getTime())
      let timestamp = milliseconds + '-' + Math.floor(Math.random() * 1000)
      let templatePayload = { ...payload, createdDate: new Date(), createdBy: getters.user.id, deleted: false }
      if (payload.tasks) {
        let templateTasks = payload.tasks.map(m => ({ ...m, taskId: timestamp + '-' + m.taskId, taskTemplateId: timestamp }))
        templatePayload = { ...templatePayload, tasks: templateTasks }
      }
      db.collection('taskTemplates').doc(timestamp).set(templatePayload)
      commit('getTemplates', { ...templatePayload, id: timestamp })
    },
    getTemplates ({commit, state}, payload) {
      state.templates = []
      state.templateTasks = []
      db.collection('taskTemplates').where('deleted', '==', false).get().then(results => {
        console.log('Getting Template TAsks')
        results.forEach(template => {
          const templateTask = template.data()
          if (templateTask.templateTaskId === '1607959777650-752') {
            console.log(templateTask.name)
          }
          commit('getTemplates', { ...template.data(), id: template.id })
        })
      })
    },
    editTemplateTask ({commit, state, dispatch, getters}, payload) {
      let newPayload = Object.assign({}, payload.createTemplateTask)
      delete newPayload.order
      delete newPayload.sortOrder
      let previousObjState = payload.previousState
      delete previousObjState.order
      delete previousObjState.sortOrder
      db.collection('settings').doc('task_templates').collection(payload.template).doc(newPayload.id).update(newPayload)
      .then(() => {
        const logData = {timestamp: new Date(), collection: 'taskTemplates', type: 'edited', changed_from: previousObjState, changed_to: newPayload, user_id: getters.user.id, record_id: newPayload.id, message: getters.user.first_name + ' edited a template task in ' + payload.template + ': ' + newPayload.name, icon: 'list'}
        dispatch('commitLog', logData)
        commit('editTemplateTask', payload)
      })
      .catch(error => {
        console.log('Database Error: ', error)
        this.$store.dispatch('setError', {timestamp: new Date(), collection: 'taskTemplates', type: 'edited', user_id: getters.user.id, route: '/tasks/templates', error: error})
      })
      // Update Tasks Based on the Execution of Other Tasks
      if (newPayload.name !== previousObjState.name) {
        db.collection('settings').doc('task_templates').collection(payload.template).where('after_task', '==', previousObjState.name).where('deleted', '==', false).get().then(query => {
          query.forEach(item => {
            db.collection('settings').doc('task_templates').collection(payload.template).doc(item.id).update({
              after_task: newPayload.name
            })
          })
        })
        const nameChangePayload = {newName: newPayload.name, previousName: previousObjState.name}
        commit('nameChange', nameChangePayload)
      }
    }
  },
  getters: {
    selectedTemplate (state) {
      return state.selectedTemplate
    },
    getTemplateTasks (state) {
      return state.templateTasks
    },
    getTemplates (state) {
      return state.templates
    },
    orderUpdateWait (state) {
      return state.orderUpdateWait
    },
    dynamicTasks (state) {
      return state.dynamicTasks
    },
    regularTasks (state) {
      return state.regularTasks
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/taskTemplates.js